<template>
  <div>
    <FlashMessage v-if="messages.text != ''" :message="messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div v-if="!showDetail" class="flex-1 p-6 lg:p-10">
          <div
            class="flex flex-col gap-4 md:flex-row justify-between items-center mb-4"
          >
            <h1 class="text-2xl font-bold text-[#1e293b]">
              Live Class Attendance List
              <span class="text-sm text-gray-400 ml-1">
                ({{ livetotal_count || 0 }})
              </span>
            </h1>
          </div>
          <div class="flex flex-col md:flex-row justify-end gap-4 mb-4">
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searching"
                @input="fetchliveclass(1)"
                placeholder="Search..."
                class="w-full rounded-2xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <button
              class="px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center gap-2 transition-all duration-200"
              @click="userdeownload"
              :disabled="isDownload || liveclass_list.length === 0"
              :class="[
                liveclass_list.length > 0
                  ? 'bg-blues hover:bg-hover cursor-pointer text-white '
                  : 'bg-gray-300 cursor-not-allowed text-gray-500 ',
              ]"
            >
              <span v-if="!isDownload" class="flex gap-1"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                  /></svg
                >Download</span
              >
              <span v-else class="flex items-center gap-2">
                <svg
                  class="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                  ></path>
                </svg>
                Download 
              </span>
            </button>
          </div>
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-textblues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
          <div>
            <div
              class="overflow-x-auto bg-white rounded-xl shadow-sm border border-[#e2e8f0] overflow-hidden"
            >
              <table class="min-w-full">
                <thead class="bg-gray-100">
                  <tr class="text-sm whitespace-nowrap">
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      S NO
                    </th>
                    <th
                      class="px-6 py-4 text-textblues text-left font-semibold border-b border-r"
                    >
                      Title
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-left"
                    >
                      Meeting Start Time
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-left"
                    >
                      Meeting End Time
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      Present
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      Absent
                    </th>
                    <th
                      class="px-6 py-4 text-textblues text-left font-semibold border-b border-r"
                    >
                      Created date
                    </th>
                    <th
                      class="px-6 py-4 text-textblues text-left font-semibold border-b"
                    >
                      Update date
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="h-[300px]">
                  <tr>
                    <td colspan="7" class="text-center py-8">
                      <div class="flex justify-center items-center">
                        <img
                          src="@/assets/newd/loading.gif"
                          alt=""
                          class="h-10"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="liveclass_list.length > 0"
                  class="bg-white divide-y divide-[#e2e8f0]"
                >
                  <tr
                    v-for="(list, index) in liveclass_list"
                    :key="index"
                    class="hover:bg-gray-50 transition-colors text-sm text-[#334155] whitespace-nowrap"
                  >
                    <td class="px-6 py-4 border-r text-center font-medium">
                      {{ (liveCurrentPage - 1) * livepageSize + index + 1 }}
                    </td>
                    <td
                      class="px-6 py-4 border-r text-left font-bold cursor-pointer text-blue-600 hover:underline"
                      @click="viewAttendance(list)"
                    >
                      <div
                        class="max-w-sm break-words whitespace-normal line-clamp-2"
                      >
                        {{ list?.title }}
                      </div>
                    </td>
                    <td class="px-6 py-4 border-r">
                      {{ formatDate(list?.start_date) }}
                    </td>
                    <td class="px-6 py-4 border-r">
                      {{ formatDate(list?.end_date) }}
                    </td>
                    <td
                      class="px-6 py-4 border-r text-center font-semibold text-green-600"
                    >
                      {{ list?.attend_count }}
                    </td>
                    <td
                      class="px-6 py-4 border-r text-center font-semibold text-red-500"
                    >
                      {{ list?.absent_count }}
                    </td>
                    <td class="px-6 py-4 border-r text-gray-500 text-left">
                      {{ formatDate(list.created_at) }}
                    </td>
                    <td class="px-6 py-4 border-r text-gray-500 text-left">
                      {{ formatDate(list.updated_at) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center py-8 text-gray-600">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- PAGINATION + PAGE SIZE -->
            <div
              v-if="livetotal_count >= 11"
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-4 flex gap-2 text-sm text-gray-600 justify-center items-center"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="livepageSize"
                  @change="onLivePageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION COMPONENT -->
              <div class="flex justify-center">
                <Pagination
                  :totalPages="liveTotalPages"
                  ref="studentPagination"
                  @page-changed="fetchliveclass"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-else class="flex-1 p-6 lg:p-10">
          <div class="flex justify-end mb-6">
            <button
              @click="goBack"
              class="bg-blues text-white px-4 py-1 text-sm font-semibold rounded-2xl hover:bg-hover transition"
            >
              Back
            </button>
          </div>
          <div class="flex flex-wrap justify-between items-center gap-4 mb-4">
            <h1 class="text-xl font-bold text-[#1e293b]">
              {{ selectedClass.title }}
              <span class="text-sm text-gray-400 ml-1">
                ({{ total_count || 0 }})
              </span>
            </h1>
          </div>
          <div class="flex flex-col md:flex-row justify-end gap-4 mb-4">
            <div class="relative md:col-span-2">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="studentsearching"
                @input="fetchstudent(1)"
                placeholder="Search.."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="studentsearching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div v-if="students.length > 0">
              <button
                class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center hover:bg-hover transition-all duration-200"
                @click="downloadUser"
                :disabled="isDownload"
              >
                <span v-if="!isDownload">Download</span>
                <span v-else class="flex items-center gap-2">
                  <svg
                    class="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                    ></path>
                  </svg>
                  Download...
                </span>
              </button>
            </div>
          </div>
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-textblues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>

          <!-- STUDENT TABLE: always render table + thead, switch tbody by state -->
          <div>
            <div
              class="overflow-x-auto bg-white rounded-2xl shadow-md border border-[#e2e8f0] overflow-hidden"
            >
              <table class="min-w-full">
                <thead class="bg-gray-100">
                  <tr class="text-sm whitespace-nowrap">
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-left"
                    >
                      S.NO
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-left"
                    >
                      Name
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-left"
                    >
                      Attendance
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b text-left"
                    >
                      Created Date
                    </th>
                  </tr>
                </thead>

                <!-- LOADING -->
                <tbody v-if="studentloading" class="h-[300px]">
                  <tr>
                    <td colspan="7" class="text-center py-8">
                      <div class="flex justify-center items-center">
                        <img
                          src="@/assets/newd/loading.gif"
                          alt=""
                          class="h-10"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>

                <!-- DATA -->
                <tbody
                  v-else-if="students.length > 0"
                  class="divide-y divide-gray-100 text-sm"
                >
                  <tr
                    v-for="(student, index) in students"
                    :key="student.id || index"
                    class="hover:bg-slate-50 whitespace-nowrap text-sm"
                  >
                    <td class="px-6 py-4 border-r font-medium">
                      {{
                        (studentCurrentPage - 1) * studentpageSize + index + 1
                      }}
                    </td>

                    <td class="px-6 py-4 border-r text-gray-700">
                      <div class="">
                        <!-- Name -->
                        <div class="font-semibold text-blue-600 text-xs">
                          <span class="capitalize">
                            {{ student.user?.display_name || "NA" }}
                          </span>
                        </div>

                        <!-- Email -->
                        <div class="text-xs text-gray-600 flex gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="12px"
                            viewBox="0 -960 960 960"
                            width="12px"
                            fill="#4B5563"
                            class="mt-1"
                          >
                            <path
                              d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                            />
                          </svg>
                          {{ student?.user?.email || "NA" }}
                        </div>

                        <!-- Meta info -->
                        <div class="text-xs text-gray-500 flex flex-wrap gap-3">
                          <span
                            ><b>PRN:</b> {{ student?.prn_number || "NA" }}</span
                          >
                          <span
                            ><b>Semester:</b>
                            {{ student?.semester || "NA" }}</span
                          >
                        </div>
                      </div>
                    </td>

                    <td class="px-6 py-4 border-r">
                      <div class="flex items-center gap-2">
                        <input
                          type="checkbox"
                          v-model="student.status"
                          :disabled="isDisabled(student)"
                          @change="onStatusChange($event, student)"
                          class="w-5 h-5 rounded border-gray-300 text-[#01b0f9] focus:ring-[#01b0f9] disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                        <span class="text-xs">
                          {{ student.status ? "Present" : "Absent" }}
                        </span>
                      </div>
                    </td>

                    <td class="px-6 py-4 text-gray-400 truncate">
                      {{ formatDate(student.created_at) }}
                    </td>
                  </tr>
                </tbody>

                <!-- NO DATA -->
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center py-8 text-gray-600">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- PAGINATION + PAGE SIZE -->
            <div
              v-if="total_count >=11"
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-4 flex gap-2 text-sm text-gray-600 justify-center items-center"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="studentpageSize"
                  @change="onStudentPageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION COMPONENT -->
              <div class="flex justify-center">
                <Pagination
                  :totalPages="studentTotalPages"
                  ref="studentPagination"
                  @page-changed="fetchstudent"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  props: ["course_id"],
  data() {
    return {
      showDetail: false,

      liveCurrentPage: 1,
      liveTotalPages: 1,
      liveclass_list: [],
      livetotal_count: "",
      livepageSize: 10,

      studentCurrentPage: 1,
      studentTotalPages: 1,
      students: [],
      studentpageSize: 10,
      total_count: "",
      loading: true,
      selectedClass: {},
      searching: "",
      studentsearching: "",
      messages: { text: "", type: "null" },
      response_message: "",
      isDownload: false,
      studentloading: false,
    };
  },

  watch: {
    selectedClass: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.fetchstudent(1);
        }
      },
      deep: true,
      immediate: false,
    },
  },

  created() {
    this.fetchliveclass(1);
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    goBack() {
      this.showDetail = false;

      this.students = [];
      this.studentCurrentPage = 1;
      this.studentTotalPages = 1;
      this.studentsearching = "";

      this.fetchliveclass(this.liveCurrentPage);
    },
    isDisabled(student) {
      if (!student.live_class?.end_date) return false;

      const endDate = new Date(student.live_class.end_date);
      const now = new Date();

      return now < endDate;
    },
    onLivePageSizeChange() {
      this.liveCurrentPage = 1;
      this.fetchliveclass(1);
    },
    onStudentPageSizeChange() {
      this.studentCurrentPage = 1;
      this.fetchstudent(1);
    },
    clearSearch() {
      if (this.showDetail) {
        this.studentsearching = "";
        this.fetchstudent(1);
      } else {
        this.searching = "";
        this.fetchliveclass(1);
      }
    },
    async fetchliveclass(page) {
      this.liveCurrentPage = page;
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/calendar/list/?course_data__id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&page_size=${this.livepageSize}`,
        );
        if (response.data.data.status == 200) {
          this.liveclass_list = response.data.data.data;
          this.liveTotalPages = response.data.total_page;
          this.liveCurrentPage = response.data.current_page;
          this.livetotal_count = response.data.total;
        } else {
          this.liveclass_list = [];
        }
      } catch (err) {
        console.error(err);
        this.liveclass_list = [];
      } finally {
        this.loading = false;
      }
    },
    async fetchstudent(page) {
      this.studentCurrentPage = page;
      this.studentloading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/live_class/attendance/list/`,
          {
            params: {
              live_class__id: this.selectedClass.id,
              Key: this.userInfo.token_key,
              page: page,
              page_size: this.studentpageSize,
              search: this.studentsearching,
            },
          },
        );

        if (response.data) {
          this.students = response.data.data || [];
          this.studentTotalPages = response.data.total_page;
          this.studentCurrentPage = response.data.current_page;
          this.total_count = response.data.total;
        } else {
          this.students = [];
        }
      } catch (err) {
        console.error(err);
        this.students = [];
      } finally {
        this.studentloading = false;
      }
    },

    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    viewAttendance(item) {
      this.selectedClass = item;
      this.showDetail = true;
    },
    async onStatusChange(event, student) {
      const newStatus = event.target.checked;
      const oldStatus = student.status;

      student.status = newStatus;

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/live-class-attendance/${student.slug}/`,
          { status: newStatus },
          {
            params: {
              Key: this.userInfo.token_key,
            },
          },
        );

        if (response.data.status === 200) {
          this.messages = {
            text: newStatus
              ? "Class joined successfully"
              : "Class unjoined successfully",
            type: "success",
          };
        } else {
          student.status = oldStatus;
          this.messages = {
            text: "Event failed",
            type: "error",
          };
        }
      } catch (error) {
        console.error(error);

        student.status = oldStatus;

        this.messages = {
          text: "Something went wrong",
          type: "error",
        };
      }

      setTimeout(() => {
        this.messages = { text: "", type: null };
      }, 2000);
    },
    async userdeownload() {
      if (this.isDownload) return;
      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/download/course-report/?Key=${this.userInfo.token_key}`,
          {
            course_id: this.course_id,
          },
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
          }, 5000);
        } else {
          this.messages = {
            text: "Event Failed",
            type: "error",
          };
          console.log("not successful");
        }
      } catch (error) {
        console.error("Delete error:", error);
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "" };
        }, 2500);
      }
    },
    async downloadUser() {
      if (this.isDownload) return;
      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/liveclass/download-by-calendar/?Key=${this.userInfo.token_key}`,
          {
            calendar_id: this.selectedClass.id,
          },
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
          }, 5000);
        } else {
          this.messages = {
            text: "Event Failed",
            type: "error",
          };
          console.log("not successful");
        }
      } catch (error) {
        console.error("Delete error:", error);
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "" };
        }, 2500);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
